'use client';
import React from 'react';
import { Layers } from 'lucide-react';

const templates = [
  { id: 'modern', label: 'Modern' },
  { id: 'minimal', label: 'Minimal' },
  { id: 'corporate', label: 'Corporate' },
  { id: 'elegant', label: 'Elegant' },
  { id: 'dark', label: 'Dark' },
  { id: 'creative', label: 'Creative' },
];

export default function TemplateSelector({ active, onSelect }: { active: string; onSelect: (t: string) => void }) {
  return (
    <div data-component-id="src/app/invoice-generator/components/TemplateSelector.tsx:16:4" data-component-path="src/app/invoice-generator/components/TemplateSelector.tsx" data-component-line="16" data-component-end-line="34" data-component-file="TemplateSelector.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-2%20flex-wrap%22%7D" className="flex items-center gap-2 flex-wrap">
      <div data-component-id="src/app/invoice-generator/components/TemplateSelector.tsx:17:6" data-component-path="src/app/invoice-generator/components/TemplateSelector.tsx" data-component-line="17" data-component-end-line="20" data-component-file="TemplateSelector.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-1.5%20text-xs%20text-muted-foreground%20font-500%20mr-1%22%2C%22textContent%22%3A%22Template%3A%22%7D" className="flex items-center gap-1.5 text-xs text-muted-foreground font-500 mr-1">
        <Layers data-component-id="src/app/invoice-generator/components/TemplateSelector.tsx:18:8" data-component-path="src/app/invoice-generator/components/TemplateSelector.tsx" data-component-line="18" data-component-end-line="18" data-component-file="TemplateSelector.tsx" data-component-name="Layers" data-component-content="%7B%22elementName%22%3A%22Layers%22%7D" size={13} />
        Template:
      </div>
      {templates.map((tpl) => (
        <button data-component-id="src/app/invoice-generator/components/TemplateSelector.tsx:22:8" data-component-path="src/app/invoice-generator/components/TemplateSelector.tsx" data-component-line="22" data-component-end-line="32" data-component-file="TemplateSelector.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
          key={`tplsel-${tpl.id}`}
          onClick={() => onSelect(tpl.id)}
          className={`px-3 py-1 rounded-lg text-xs font-600 transition-all ${
            active === tpl.id
              ? 'bg-primary text-white shadow-sm'
              : 'bg-muted text-muted-foreground hover:bg-primary/10 hover:text-primary'
          }`}
        >
          {tpl.label}
        </button>
      ))}
    </div>
  );
}